<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item"><router-link to="/admin/penjualan">Penjualan</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Invoice</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Invoice</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
                
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9 justify-content-center">

                       
                                <!-- Success Card -->
                                <div class="card success-card">
                                    <div class="card-body">
                                        <div class="success-cont">
                                            <i class="fas fa-check"></i>
                                            <h3>Pembelian Paket Berhasil!</h3>
                                            <p>Paket {{paketsales.nama_paket}}</p>
                                            
                                            <!-- <btn class="btn btn-primary view-inv-btn" @click.prevent="mulaiBelajar(paketsales)">
                                                Ayo Mulai Belajar
                                            </btn> -->
                                        </div>
                                    </div>
                                </div>
                                <!-- /Success Card -->
                            
                            
						</div>
                    </div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
			

	</div>
		<!-- /Main Wrapper -->
</template>


<script>
import Sidebar from '../../Sidebar'
import axios from 'axios';
import axiosXendit from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'paket-belajar',
    // vuetify: new Vuetify(),
    data() {
        return {
            paketsales: '',
        }
    },
    created: function () {
        this.getInvoice();
      
    },  

    methods: {
       
        getInvoice: function () {
             axios.get('api/invoice/'+localStorage.getItem("idPaket"))//+this.$route.params.id)
                .then(res => {
                    this.paketsales = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })

           
        },

        
        mulaiBelajar: function (ref) {
            
            localStorage.setItem("idPaket", ref.id_paket);  //idPaket: ref.id_paket,  
            this.$router.push({name:'siswa-paket-saya-detail'});         
            // this.$router.push({name:'siswa-paket-saya-detail', params: {idUser: localStorage.getItem('idUser'), idPaket: ref.id_paket}}); 
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/PaketBelajar/InvoiceGratis/index.vue